import { useIntl } from "react-intl";
const PostIncidentReviews = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.PostIncidentReviews.header",
            defaultMessage: "Post-incident reviews"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.PostIncidentReviews.body",
            defaultMessage:
                "Understand all contributing root causes, and document the incident for future reference and pattern discovery. Post-incident reviews also let you enact preventative actions to reduce the likelihood or impact of recurrence."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default PostIncidentReviews;
